type FloatLikeString = string;

export const limitFloatFractionLengthFactory =
  (limit: number) => (target: FloatLikeString) => {
    const [_, fraction] = target.split('.');

    const fractionLength = (fraction || '').length;

    /**
     * Negative value or zero
     *
     * If we pass negative value, slice will count index back
     * from the end of the array
     */
    const end = limit - fractionLength;

    return fractionLength > limit ? target.slice(0, end) : target;
  };
